/* Progressive enhancement: content and collection links work without JavaScript. */
(() => {
  function mount(root) {
    root.querySelectorAll('[data-sw-experience]').forEach(experience => {
      if (experience.dataset.swReady) return;
      const tabs = [...experience.querySelectorAll('[data-sw-tab]')];
      const panels = [...experience.querySelectorAll('[data-sw-panel]')];
      if (!tabs.length || tabs.length !== panels.length) return;
      experience.dataset.swReady = 'true';
      experience.querySelector('[data-sw-tabs]').setAttribute('role', 'tablist');
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[i].id);
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].tabIndex = 0;
        tab.addEventListener('click', event => {event.preventDefault(); event.stopPropagation(); select(i);});
        tab.addEventListener('keydown', event => {
          if (event.key === ' ') { event.preventDefault(); select(i); return; }
          const rtl = document.documentElement.dir === 'rtl';
          let target;
          if (event.key === 'ArrowRight') target = i + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') target = i + (rtl ? 1 : -1);
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          if (target !== undefined) {event.preventDefault();select((target + tabs.length) % tabs.length, true);}
        });
      });
      const initial = tabs.findIndex(tab => tab.getAttribute('href') === window.location.hash);
      select(initial >= 0 ? initial : 0);
    });
  }
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
